export const calendar = {
  title: "Calendário",
  subtitle: "Gerencie as reservas das suas propriedades",
  createBooking: "Criar reserva",
  propertyLabel: "Acomodação",
  searchPlaceholder: "Buscar acomodação",
  filterByProperty: "Filtrar propriedades",
  clearFilters: "Limpar filtros",
  loadingMore: "Carregando mais datas…",

  payment: {
    "pending":  "Pagamento pendente",
    "paid":     "Pago",
    "rejected": "Pagamento recusado",
    "refunded": "Reembolsado",
    "partial":  "Pagamento parcial"
  },

  tooltips: {
    noChannels: "Não conectado a nenhum canal",
    connectedTo: "Conectado a: {channels}",
    manual: "WA Checkin (manual)",
    other: "Outro canal",
    configPrices: "Configurar preços",
  },

  errors: {
    loadCalendar: "Erro ao carregar os dados do calendário",
    updateViewAfterCancel: "Erro ao atualizar a exibição após o cancelamento",
    closeDates: "Erro ao fechar as datas",
    deleteClosedDates: "Erro ao excluir as datas fechadas",
    updateClosedDates: "Erro ao atualizar as datas fechadas",
  },

  filters: {
    showPrices: "Mostrar preços",
    today: "Hoje",
    multi: "Múltiplo",
    monthly: "Mensal",
    prevMonthAria: "Mês anterior",
    nextMonthAria: "Próximo mês",
  },

  actions: {
    title: "Selecione uma ação",
    question: "O que você gostaria de fazer com as datas selecionadas?",
    createBooking: "Criar reserva",
    blockDates: "Fechar data",
    editNightPrice: "Editar preço por noite",
    editMinStay: "Estadia mínima",
    editMinStayHint: "Defina o número mínimo de noites por data",
  },
  minStayModal: {
    description:
      "Defina a estadia mínima para o período de datas selecionado. Isso não afetará os preços existentes.",
    success: "Estadia mínima atualizada com sucesso",
    hint: "Número mínimo de noites que o hóspede deve reservar.",
    errors: {
      minOne: "A estadia mínima deve ser de pelo menos 1 noite.",
    },
  },

  fields: {
    startDate: "Data de início",
    endDate: "Data de término",
  },

  buttons: {
    delete: "Excluir",
    cancel: "Cancelar",
    save: "Salvar",
    close: "Fechar",
    saveChanges: "Salvar alterações",
    closeDates: "Fechar datas",
  },

  closeModal: {
    headerCreate: "FECHAR DATAS",
    headerEdit: "EDITAR DATAS FECHADAS",
  },

  priceModal: {
    description:
      "Esta é uma alteração manual na tarifa que você selecionar. Tudo o que você alterar aqui afetará apenas esta acomodação e este período de datas.",
    periodLabel: "Período de datas",
    startPlaceholder: "Data de início",
    endPlaceholder: "Data de término",
    pricePerNight: "Preço por noite",
    minStay: "Estadia mínima",
    minNightsPlaceholder: "Noites mínimas",
    pricePlaceholder: "Preço para o período selecionado",
    success: "Preços atualizados com sucesso",
    errors: {
      invalidRange: "Você deve selecionar um período de datas válido",
      startAfterEnd: "A data de início não pode ser posterior à data de término",
      minStay:
        "A estadia mínima é de {min} noites, mas o período selecionado tem {nights} noites",
      missingSelection: "Nenhuma propriedade ou período de datas foi selecionado",
      request: "Erro na solicitação: {msg}",
      update: "Erro ao atualizar os preços: {msg}",
    },
  },

  details: {
    header: "Detalhes da reserva",
    title: "Reserva",
    createdOn: "Criada em {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Status",
    status: {
      booked: "Reservado",
      blocked: "Bloqueado",
    },
    night_one: "Noite",
    night_other: "Noites",
    actions: {
      view: "Ver reserva",
      changeRoom: "Trocar de quarto",
      cancel: "Cancelar reserva",
    },
  },
};

export default calendar;